<template>
	<div class="bindlist">
		<div v-if="userInfo.phone" class="nowphone">
			当前绑定手机号:{{userInfo.phone}}
		</div>
		<Field :border="false" v-model="phone" type="number" maxlength="11" placeholder="请输入手机号码" @input="checkphone" />
		<cell-group :border="false">
			<Field
			v-model="smscode"
			center
			clearable
			type="number"
			maxlength="6" 
			placeholder="请输入验证码"
			>
				<Button slot="button" size="small" type="warning" @click="getsms" plain round :disabled="smsdisabled">{{btntips}}</Button>
			</Field>
		</cell-group>
		<div class="bindphone-container-padding bindphonefooter footer">
			<Button  type="warning" round @click="addMember" :disabled="phone == '' || smscode== ''" >确定绑定</Button>
		</div>
	</div>
</template>

<script>
	import './bindphone.less'
    import {registerverify,userinfolist,editregisteruser} from '@/libs/api'
    import {Button,Field,CellGroup,Dialog} from 'vant'
    import { getStorage, checkMobile} from '@/libs/utils'

    export default {
        name: 'bindphone',
        components: {
            Button,
            Field,
            CellGroup
        },
		data() {
			return {
				phone: '',
				smscode: '',
				userInfo: {},
				smsdisabled: true,
				btntips: '获取验证码',
				urid: '',
				token: ''
			}
		},
		methods:{
			addMember(){
				if (checkMobile(this.phone)&&this.smscode != '') {
					editregisteruser({mobile: this.phone, verifycode: this.smscode, name: this.userInfo.name,urid:this.urid,token:this.token}).then((res) => {
						if (res.status == 200) {
							Dialog({ message: '绑定成功' });
							userinfolist({urid:this.urid,token:this.token}).then((res) => {
								if (res.status == 200) {
									this.userInfo = res.data
									this.phone = ''
									this.smscode =  ''
									this.smsdisabled = true
									this.btntips = '获取验证码'
								} else {
									this.userInfo = {}
								}
							})
						} else {
							this.smscode =  ''
						}
					})
				}else{
					Dialog({ message: '请输入手机号和验证码' });
				}
			},
			checkphone(val){
				if(checkMobile(val)){
					this.smsdisabled = false
				}else{
					this.smsdisabled = true
				}
			},
			getsms(){
				//判断手机号码一致
				if (this.phone == this.userInfo.phone) {
					Dialog({ message: '请输入新的手机号码' });
					return;
				}
				if (checkMobile(this.phone)) {
					var sec = 60;
					var that = this
					for (let i = 0; i <= 60; i++) {

						setTimeout(function () {
							if (sec != 0) {
								that.btntips = sec + "秒后重发验证"
								that.smsdisabled = true
								sec--
							} else {
								sec = 60//如果倒计时结束就让  获取验证码显示出来
								that.btntips = '获取验证码'
								that.smsdisabled = false
							}
						}, i * 1000)
					}
						registerverify({mobile: this.phone,action: 2,urid:this.urid,token:this.token}).then()
				} else {
					// console.log(12);
				}
			}
		},
        mounted() {
			this.$nextTick(() => {
				let userinfo = getStorage('userInfo')
				this.urid = userinfo.urid
				this.token = userinfo.token
				userinfolist({urid:this.urid,token:this.token}).then((res) => {
					if (res.status == 200) {
						this.userInfo = res.data
					} else {
						this.userInfo = {}
					}
				})
			})
		}
        
    }
</script>